<template>
  <div>
    <div class="mains" @click.stop="close()">
      <div class="comtainer" @click.stop>
        <div class="top">
          <div class="select">
            <Input v-model="selectVal" search placeholder="输入字段标题或ID" />
          </div>
        </div>
        <div class="main">
          <Table border :columns="columns" :data="pageData" style="width: 100%;height:100%;">
            <template #action="{ index }">
              <Button type="success" @click="setClient(index)">选择</Button>
            </template>
          </Table>
          <!-- 分页 -->
          <Page class="page" :modelValue="pages" :total="allPage" simple @on-change="page" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetClients } from "@/api/index";
export default {
  data() {
    return {
      values: [],
      columns: [
        {
          title: "id",
          key: "id",
          width: 65,
          // fixed: 'left'
        },
        {
          title: "企业代码",
          key: "incode",
          width: 120,
          // fixed: 'left'
        },
        {
          title: "企业名称",
          key: "name",
          minWidth: 250,
        },
        {
          title: "账号",
          key: "account",
          minWidth: 100,
        },
        {
          title: "功能",
          key: "module",
          minWidth: 250,
        },
        {
          title: "行业",
          key: "city",
          minWidth: 250,
        },
        {
          title: "地址",
          key: "site",
          minWidth: 300,
        },
        {
          title: "到期时间",
          key: "date",
          minWidth: 200,
        },
        {
          title: " ",
          slot: "action",
          width: 100,
          align: "center",
          fixed: "right",
        },
      ],
      // 源数据
      datas: [],
      // 搜索后的数据
      inData: [],
      // 分页后的数据
      pageData: [],
      pages: 1,
      allPage: 1,
      selectVal: ''
    };
  },
  mounted() {
    // 获取企业信息
    GetClients({
      code: 1,
    }).then((res) => {
      this.datas = res;
      //   初始列表过滤10
      this.pageData = res.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.allPage = this.datas.length;
    });
  },
  watch: {
    // 搜索过滤
    selectVal(newVal, oldVal) {
      var data = this.datas.filter((p) => {
        if (p.incode.indexOf(newVal) !== -1) {
          return p;
        }
        if (p.name.indexOf(newVal) !== -1) {
          return p;
        }
      });
      this.pages = 1;
      this.allPage = data.length;
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
  },
  computed: {
    SelectValue() {
      var str = "";
      for (let index = 0; index < this.values.length; index++) {
        str = str + this.values[index] + ",";
      }
      return str;
    },
  },
  methods: {
    getFiledData() {
      this.values = this.FiledData.split(',')
    },
    setClient(index) {
      var str = this.pageData[index].incode
      this.$emit('Value', str);
      this.close()
    },
    close() {
      this.$emit('close', true)
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      var data = this.datas.filter((p) => {
        return p.name.indexOf(this.selectVal) !== -1;
      });
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
  },
};
</script>

<style scoped>
.mains {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.comtainer {
  display: block;
  padding: 15px;
  width: 900px;
  height: auto;
  max-height: 700px;
  background: white;
}

.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.main {
  height: calc(100% - 47px);
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}</style>
